import React from 'react'
import { IPublicProfile } from 'interfaces/IPublicProfile'
import { Emoji } from '../Emoji';

export const Accuracy: React.FunctionComponent<{ profile: IPublicProfile }> = ({ profile }) => {
  return <div className="d-flex gap-1 justify-content-center align-items-center"><Emoji symbol="🎯" text={""} label="accuracy" /> {Math.round(profile.predictions.averageScore as number * 100)}%</div>
}
